import { getConfig } from '../config';
import { OAuthentication } from '../lib/Authentication';
import {
  deauthorizeAccount,
  fetchRefreshToken,
  getMe,
  postLogin,
  registerAccount,
} from '../services/AccountService';
import appSetupStore from './appSetupStore';

export const navigateToLogin = () => {};

const defaultProps = {
  loginRequest: postLogin,
  registerRequest: registerAccount,
  getProfileRequest: getMe,
  refreshTokenRequest: fetchRefreshToken,
  deauthorizeRequest: deauthorizeAccount,
  navigateToLogin,
  roleType: getConfig('AUTH_ROLE_TYPE'),
  rolesAllowed: getConfig('AUTH_ROLES_ALLOWED'),
};

export const appSetupAuth = new OAuthentication({
  storage: appSetupStore,
  ...defaultProps,
});

export default appSetupAuth;
